<template>
    <div>
        <vFormItem
            :label="$t('fbb.organization.can_use_service', { defaultValue: '可使用的服务' })"
            label-width="150"
            v-if="type !== 'query'"
        >
            <vTransfer
                style="height:360px;"
                :data="getCarrierServiceList"
                identifier="value"
                :target-keys="targetKeys"
                :list-style="listStyle"
                :render-format="renderFormat"
                :filter-method="filterMethod"
                filterable
                @on-transfer="handleChange"
            ></vTransfer>
        </vFormItem>
        <TableList v-else v-bind="getTableProps"></TableList>
    </div>
</template>

<script>
import TableList from "@components/templates/tablelist";
import { HttpOrgCarrierService } from "@/service/basicdata";
import { mapGetters } from 'vuex';
export default {
    components: {
        TableList
    },
    data() {
        return {
            type: this.$route.params.type,
            id: this.$route.query.id,
            orgId: this.$route.query.orgId,
            targetKeys: [],
            listStyle: {
                width: "30%",
                minWidth: "260px"
            }
        };
    },
    created() {
        this.getTargetKeys();
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceList']),
        getTableProps() {
            return {
                ajaxRequest: HttpOrgCarrierService,
                startUp: 1,
                initFormData: {
                    orgId: this.orgId,
                },
                columns: [
                    {
                        title: this.$t('fbb.warehouse.sequence', { defaultValue: "序号" }),
                        type: "index",
                        width: 100
                    },
                    {
                        title: this.$t('erp.b2c.hippingMethodCode', { defaultValue: "物流服务" }),
                        key: "key",
                        render: (h, { row }) =>
                            this.findRenderLabel(this.getCarrierServiceList, row.key)
                    }
                ]
            };
        }
    },
    methods: {
        renderFormat(item) {
            return item.description
                ? `${item.label}-${item.description}`
                : item.label;
        },
        handleChange(targetKeys, direction, moveKeys) {
            // console.log(targetKeys);
            this.targetKeys = targetKeys;
        },
        //获取服务list
        getTargetKeys() {
            if (this.type === 'add') return;
            HttpOrgCarrierService({
                page: 1,
                rows: 2000,
                orgId: this.orgId,
            }).then(res => {
                const data = res.data || {};
                this.targetKeys = data.content || []
            })
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
    }
};
</script>
